import { render, staticRenderFns } from "./orderStatementCreatePage.vue?vue&type=template&id=6bd5764d&"
import script from "./orderStatementCreatePage.vue?vue&type=script&lang=ts&"
export * from "./orderStatementCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports